module.exports = "assets/img/mail@2x.png";